<template>
  <div class="jobs-list" v-loading="loader">
     <span class="obj-name" v-if=" $route.query.docs_name">
        Выбранный раздел: <strong>{{ ` ` + $route.query.docs_name }}</strong>
      </span>
    <router-link :to="getUrl()" class="add-job">
      <el-button>+ Добавить документы</el-button>
    </router-link>

    <el-form>
      <el-input placeholder="Поиск ..." v-model="search" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
    </el-form>
    <draggable
      class="jobs-ul"
      handle=".handle"
      :list="jobs"
      @change="save"
    >
      <div class="jobs-li" v-for="(job, index) in filteredList" :key="index">
        <div class="jobs-text">
          <i class="fa fa-align-justify handle"></i>
<!--          <a @click="downloadURI(job.file, job.name)" v-if="!job.editable">{{ job.name }}</a>-->
<!--          IOS ONLY-->
          <a :href="job.file" target="_blank" v-if="!job.editable">{{ job.name }}</a>

          <el-input type="textarea" v-else v-model="job.name" @blur="edit(job)"></el-input>
        </div>
        <span>
          <i class="fa fa-trash" @click="deleteObject(job.id)" style="margin-right: 28px"></i>

            <i class="fa fa-edit" @click="job.editable = !job.editable" style="margin-right: 28px"></i>

            <i class="fa fa-link" v-clipboard:copy="job.file"  v-clipboard:success="onCopy"></i>
        </span>
      </div>
    </draggable>
  </div>
</template>

<script>
import firebase from 'firebase';
import draggable from 'vuedraggable';
import _ from 'lodash';
import FilterSelect from '../../../components/FilterSelect';
import {downloadURI} from "../../../utils/urlUtils";

export default {
  name: 'List',
  components: {FilterSelect, draggable},

  data() {
    return {
      loader: false,
      search: '',
      jobs: [],
      list: [],
      permission: [],
      object: null,
    }
  },
  async mounted() {
    this.fetchJobs();
  },

  methods: {
    downloadURI,
    updateJobs() {
      this.fetchJobs();
    },
    onCopy() {
      this.$notify.success({
        offset: 60,
        title: 'Ссылка скопирована',
      });
    },
    edit(file) {
      file.editable = false
      this.loading = true;
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('files').doc(file.id)
        .update({
          name: file.name,
        }).then((add) => {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Файл отредактирован',
          type: 'success',
        });
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    deleteObject(id) {
      this.$confirm('Вы действительно хотите удалить файл?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('files')
          .doc(id).delete()
          .then((data) => {
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
            this.fetchJobs();
          });
      });
    },
    save: _.debounce(function (el, binding) {
      const jobs = this.jobs.map((job, index) => {
        return {
          ...job,
          _data: {
            job: job._data,
            index: index,
          },
        };
      });

      this.update(jobs);
    }, 1000),
    update(jobs) {
      let batch = myFirestore.batch();
      jobs.forEach((doc) => {
        const docRef = myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('files')
          .doc(doc.id);
        batch.update(docRef, doc._data);
      });
      batch.commit();
    },
    getUrl() {
      return `/dashboard/files/${this.$route.query.docs || this.$route.params.id || 'new'}/create/`;
    },
    fetchJobs() {
      this.loader = true;
      const result = [];
      let req = null;
      if (this.$route.params.id) {
        req = myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('files')
          .where(`documentation`, 'array-contains-any', [this.$route.params.id]);
      } else {
        req = myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('files')
      }
      req.get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              file: data.file,
              editable: false,
            });
          });
        })
        .finally(() => {
          this.jobs = _.orderBy(result, '_data.index', ['asc']);
          this.loader = false;
        });
    },
  },

  computed: {
    filteredList() {
      return this.jobs.filter((job) => {
        const search = job.name.toLowerCase().includes(this.search.toLowerCase());
        if (this.object && this.object.value) {
          return search && job._data.objects.includes(this.object.value);
        }
        return search;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-list {
  max-width: 428px;
  width: calc(100% - 40px);
  margin: 22px auto;
  padding-top: 20px;
}

.jobs-text {
  display: flex;
  align-items: center;
  overflow: hidden;
  max-width: 60%;
  text-overflow: ellipsis;

  a {
    color: #000;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      text-decoration: underline;
    }
  }

  .handle {
    margin-right: 30px;
  }
}
@media screen and (max-width: 764px) {
  .jobs-text {
    max-width: 96% !important;
  }
  .jobs-li {
    flex-direction: column !important;
    align-items: flex-start !important;
    border-bottom: 1px solid #ddd !important;

    span {
      width: 100% !important;
      text-align: right !important;
      margin-top: 10px !important;
    }
  }
}


.input-search {
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 36px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 8px 12px;
    text-align: left;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.notify {
  background: #f0f0f0;
  color: #888;
  font-size: 13px;
  padding: 8px 4px;
  border-radius: 4px;
}

.add-job {
  > > > button {
    width: 100%;
    margin-top: 12px;
  }
}

.fa-edit {
  color: #000;
}

.checkbox-list {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;

  i {
    margin-right: 10px;
  }

  span {
    text-align: left;
    font-size: 14px;
    margin-left: 8px;
  }
}

.jobs-list {
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Files/List.vue